exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Kot5KcY3tSH9aeUUxsR3m{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1g3qsa6yUaV2t0UzlS9LAx{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;white-space:nowrap}html[dir=ltr] .r9t4BKOqQN_wZU8h9R9nE{padding-right:10px}html[dir=rtl] .r9t4BKOqQN_wZU8h9R9nE{padding-left:10px}", ""]);

// exports
exports.locals = {
	"enrollDomain_container": "_2Kot5KcY3tSH9aeUUxsR3m",
	"domain_btn_container": "_1g3qsa6yUaV2t0UzlS9LAx",
	"enrollDomain_description": "r9t4BKOqQN_wZU8h9R9nE"
};